<template>
  <span class="viz-sub-label" :class="{ 'mt-3': spaced }">
    {{ label }}
    <v-tooltip top max-width="320">
      <template #activator="{ on, attrs }">
        <v-icon
          v-bind="attrs"
          x-small
          tabindex="0"
          class="option-info__icon"
          :aria-label="`About ${label}`"
          v-on="on">
          mdi-information-outline
        </v-icon>
      </template>
      <span class="option-info__text">{{ help }}</span>
    </v-tooltip>
  </span>
</template>

<script>
/**
 * A wizard option label with an inline "what does this do?" tooltip.
 *
 * Exists because the Behavior step carries several options whose NAMES do not explain their effect —
 * most sharply the two colour definitions (chart series schema vs 3D property colours), which a user
 * could previously set both of with no way to tell which one governed. Help text lives at each
 * control instead of in a manual nobody opens.
 *
 * Renders the same `.viz-sub-label` the step's plain labels use, so swapping a label for this
 * component does not shift the layout.
 */
export default {
  name: 'OptionInfo',
  props: {
    /** Visible label text — identical to the plain <span> it replaces. */
    label: { type: String, required: true },
    /** Tooltip body. Must explain the option's EFFECT; never restate the label. */
    help: { type: String, required: true },
    /** Adds the `mt-3` the stacked labels in this step use. */
    spaced: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.option-info__icon {
  margin-left: 4px;
  vertical-align: text-bottom;
  opacity: 0.55;
  cursor: help;
}

.option-info__icon:hover,
.option-info__icon:focus-visible {
  opacity: 1;
}

/* Tooltip copy is a sentence, not a label — allow it to wrap and breathe. */
.option-info__text {
  display: block;
  line-height: 1.45;
}
</style>
